import { RootState } from '@/store/store';
import { createSlice } from '@reduxjs/toolkit';

type IConf = {
  openedNav: boolean;
};

const initialState: IConf = {
  openedNav: false,
};

export const confSlice = createSlice({
  name: 'conf',
  initialState,
  reducers: {
    toggle: (state) => {
      return { ...state, openedNav: !state.openedNav };
    },
  },
});

export const { toggle } = confSlice.actions;
export const selectConf = (state: RootState) => state.conf;
export default confSlice.reducer;
